import { bool, func, number, oneOfType, string } from 'prop-types';
import React from 'react';
import { Col, FormGroup } from 'reactstrap';

import MultiSelect from '../../generic/MultiSelect';
import SingleSelect from '../../generic/SingleSelect';
import { getTooltipLabelWithText } from '../../generic/Tooltip';
import { campaignShape, quoteShape } from '../../prop-types';
import {
  allowedFlexibilitiesOptions,
  allowedFlexibilitiesValues,
  flexibilityTermsOptions,
  flexibilityTermsValues,
} from '../../quotes/constants';
import HELP_TEXTS from '../utils/help-texts';

function FlexibilityTerms({
  model,
  isRequired,
  labelwidth,
  contentwidth,
  section,
  onChange,
  readOnly,
}) {
  const { flexibilityTerms, allowedFlexibilities = [] } = model.quote || model;

  const TooltipLabel = getTooltipLabelWithText(HELP_TEXTS);

  const isLimitedFlexibility =
    flexibilityTerms === flexibilityTermsValues.LIMITED_FLEXIBILITY;

  const handleFlexibilityTermsChange = e => {
    onChange(e);
    onChange({
      target: {
        name: 'allowedFlexibilities',
        value: [],
      },
    });
  };

  const handleAllowedFlexibilityTermsChange = e => {
    onChange(e);
    const { value } = e.target;
    // If No flexiblity is selected then user should not be able to combine it with any other options.
    if (value.indexOf(allowedFlexibilitiesValues.NO_FLEXIBILITY) > -1)
      onChange({
        target: {
          name: 'allowedFlexibilities',
          value: [allowedFlexibilitiesValues.NO_FLEXIBILITY],
        },
      });
  };

  return (
    <>
      <FormGroup row>
        <TooltipLabel
          helpKey="flexibilityTerms"
          text="Flexibility Terms"
          colWidth={labelwidth}
          resource={section}
          className={isRequired ? 'required' : ''}
        />
        <Col sm={contentwidth}>
          <SingleSelect
            options={flexibilityTermsOptions}
            id={`${section}-flexibilityTerms`}
            name="flexibilityTerms"
            value={flexibilityTerms}
            onChange={handleFlexibilityTermsChange}
            readOnly={readOnly}
          />
        </Col>
      </FormGroup>
      {isLimitedFlexibility && (
        <FormGroup row>
          <TooltipLabel
            helpKey="allowedFlexibilities"
            text="Allowed flexibility"
            colWidth={labelwidth}
            resource={section}
          />
          <Col sm={contentwidth}>
            <MultiSelect
              options={allowedFlexibilitiesOptions}
              id={`${section}-allowedFlexibilities`}
              name="allowedFlexibilities"
              value={allowedFlexibilities}
              onChange={handleAllowedFlexibilityTermsChange}
              readOnly={readOnly}
            />
          </Col>
        </FormGroup>
      )}
    </>
  );
}

FlexibilityTerms.propTypes = {
  model: oneOfType([quoteShape, campaignShape]).isRequired,
  isRequired: bool,
  labelwidth: number.isRequired,
  contentwidth: number.isRequired,
  section: string.isRequired,
  onChange: func,
  readOnly: bool,
};

FlexibilityTerms.defaultProps = {
  isRequired: false,
  readOnly: false,
  onChange: () => {},
};

export default FlexibilityTerms;
